import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-agris-confirm-dialog',
  templateUrl: './agris-confirm-dialog.component.html',
  styleUrls: ['./agris-confirm-dialog.component.scss', '../agris-common-styles.scss']
})
export class AgrisConfirmDialogComponent implements OnInit {

  public title = '';
  public message = '';
  public possitive = 'ACEPTAR';
  public negative = 'CANCELAR';

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/common/agris-confirm-dialog/agris-confirm-dialog.component.ts